import React from "react";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import useAIConfigs from "@/hooks/useAIConfigs";
import { useNavigate } from "react-router-dom";

export default function AINewCreateChatbotButton() {
  const { add } = useAIConfigs();
  const navigate = useNavigate();

  const handleCreate = async () => {
    add();
    navigate("/ai-new/settings");
  };

  return (
    <PrimaryBlueButton
      label="New Chatbot"
      onClick={handleCreate}
    />
  );
}
